import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookie from 'js-cookie';
document.querySelectorAll('.g-nav-open').forEach(gnav => {
    gnav.addEventListener('click', function (e) {
        this.classList.toggle('active');
        document.getElementById('g-nav').classList.toggle('panelactive');
        document.body.classList.toggle('no-scrol');
    }.bind(gnav))
});

document.querySelectorAll('#g-nav a').forEach(gnavLink => {
    gnavLink.addEventListener('click', () => {
        document.querySelectorAll('.g-nav-open').forEach((gnav) => {
            gnav.classList.remove('active');
        })
        document.getElementById('g-nav').classList.remove('panelactive');
        document.body.classList.remove('no-scrol');
    })
});

document.querySelectorAll('.js_h').forEach(jsh => {
    ['mouseenter', 'touchstart'].forEach(event => {
        jsh.addEventListener(event, () => {
            jsh.classList.add('hover');
        })
    });
    ['mouseleave', 'touchend'].forEach(event => {
        jsh.addEventListener(event, () => {
            jsh.classList.remove('hover');
        })
    });
});

const yearSelect = document.getElementById('selector-archive-fiscal-year');
if (yearSelect != null) {
    yearSelect.addEventListener('change', function () {
        window.location.href = this.value;
    }, false);
}

const pagetopBtn = document.querySelector('#page-top');
pagetopBtn.addEventListener('click', () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
});

const THE_COOKIE = '_oggs_privacy_consent_en';
const consentPanel = document.getElementById('consentPanel');
const instagramFeed = document.getElementById('instagram_feed');
const consent = Cookie.get(THE_COOKIE);
const COOKIE_LIFETIME = 7 * 4 * 3; // 7 days * 4 weeks * 3 months

if (undefined === consent) {
    consentPanel.style.display = 'block';
} else {
    consentPanel.style.display = 'none';
}

if (consentPanel.style.display === 'block') {
    document.getElementById('consent-agreed').addEventListener('click', function () {
        console.log('agreed');
        Cookie.set(THE_COOKIE, 'true', {expires: COOKIE_LIFETIME});
        consentPanel.style.display = "none";
        if(instagramFeed){
            instagramFeed.style.display = "block";
        }
        location.reload();
    });

    document.getElementById('consent-disagreed').addEventListener('click', function () {
        console.log('disagreed');
        Cookie.set(THE_COOKIE, 'false', {expires: COOKIE_LIFETIME});
        consentPanel.style.display = "none";
    });
}

const btnCookieReactivate = document.querySelector('.btn-call-cookie-accept > a.wp-block-button__link');
if (btnCookieReactivate !== null) {
    btnCookieReactivate.addEventListener('click', function (ev) {
        console.log('reactivate cookie');
        Cookie.set(THE_COOKIE, 'true', {expires: COOKIE_LIFETIME});
        consentPanel.style.display = "none";
        location.reload();
    })
}


